import { useEffect, useState } from "react";
import { pdfjs } from "react-pdf";
import { useLocation } from "react-router-dom";
// import './style1.css';



export default function PdfViewer() {
  const location = useLocation();
  const pdfUrl = new URLSearchParams(location.search).get("pdf");
  const [images, setImages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const imagesPerPage = 3;

  useEffect(() => {
    if (!pdfUrl) return;
    async function loadPdf() {
      const loadingTask = pdfjs.getDocument(pdfUrl);
      const pdf = await loadingTask.promise;
      let pages = [];
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale: 2 });
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: context, viewport }).promise;
        pages.push(canvas.toDataURL("image/png"));
      }
      setImages(pages);
    }
    loadPdf();
  }, [pdfUrl]);

  const totalPages = Math.ceil(images.length / imagesPerPage);
  const paginatedImages = images.slice((currentPage - 1) * imagesPerPage, currentPage * imagesPerPage);

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold">PDF Viewer</h1>
      {pdfUrl ? (
        <>
          {/* <div className="grid grid-cols-1 gap-4">
            {paginatedImages.map((img, index) => (
              <Card key={index}>
                <CardContent>
                  <img src={img} alt={`Page ${index + 1}`} className="w-full h-auto rounded" />
                </CardContent>
              </Card>
            ))}
          </div> */}
          {/* <div className="flex justify-between mt-4">
            <Button onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}>
              Previous
            </Button>
            <span>Page {currentPage} of {totalPages}</span>
            <Button onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages}>
              Next
            </Button>
          </div> */}
          {/* <Button as="a" href={pdfUrl} download className="mt-4">
            Download PDF
          </Button> */}
        </>
      ) : (
        <p>No PDF found. Please select a PDF.</p>
      )}
    </div>
  );
}
